import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFound.css';
import { APP_NAME, LOGO_SRC, getCurrentYear } from '../config/branding';

const NotFound = () => {
  const navigate = useNavigate();

  const handleLogo = () => {
    navigate('/');
  };

  return (
    <div className="notfound">

    <div className="signin-header" onClick={handleLogo}>
      <img
      src={LOGO_SRC}
      alt={APP_NAME}
      style={{ marginLeft: '10px', height: '40px', width: 'auto', maxWidth: '160px', borderRadius:'3px'}}
      />
      </div>

        <svg className='image'
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>

        <h1 className="heading">404 - Page Not Found</h1>
        <p className="text">Sorry, the page you are looking for does not exist.</p>
        <button className="button" onClick={() => navigate('/')}>
          Go Home
        </button>

      <div className="signin-footer">
        <div className="footer-subject">© {getCurrentYear()} {APP_NAME}</div>
        <Link to="/privacy" className="footer-subject">Privacy</Link>
        <Link to="/docs" className="footer-subject">Documentation</Link>
        <Link to="/contact" className="footer-subject">Contact</Link>
      </div>
    </div>
  );
};

export default NotFound;
